import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {UsefulLinksListBox} from '../../boxes/useful-links-list/useful-links-list.box';
import {observer} from 'mobx-react';
import {styled} from '@mui/material';

export interface UsefulLinksListComponentProps {
    onItemClick?: () => void;
    // this will be UserMenuSectionBox in general except for mini orbit where it is gonna be MiniOrbitUsefulLinksListBox
    linksGroupWrapperBox?: React.ComponentType<{className?: string}>;
    linksGroupWrapperClassName?: string;
}

@observer
export class UsefulLinksListComponent extends OrbitComponent<UsefulLinksListComponentProps> {
    render() {
        const LinksGroupWrapperBox = this.props.linksGroupWrapperBox ? this.props.linksGroupWrapperBox : styled.div``;
        return this.services.userMenu.usefulLinksMenuItems.map((list, index) =>
            <LinksGroupWrapperBox className={this.props.linksGroupWrapperClassName} key={"list_"+index}>
                <UsefulLinksListBox className='cy-useful-links-list'>
                    { list.map((menuItem, index) => menuItem.renderMenuItem({onBeforeClick: this.props.onItemClick, showSeparator: !!index}) )}
                </UsefulLinksListBox>
            </LinksGroupWrapperBox>
        )
    }
}
